import type { RiskGapType } from '@ctw/shared/api/fhir/models/risk-gap';
import type { BadgeProps } from '@ctw/shared/components/badge';

export const riskGapTypeBadgeDefinition = (gapType: RiskGapType): BadgeProps => {
  switch (gapType) {
    case 'recapture': {
      return {
        variant: 'info-secondary',
        content: 'Recapture',
        testId: 'risk-gap-type-badge-recapture',
        className: 'bg-success-badge text-success-main border-success-main',
      };
    }
    case 'suspect': {
      return {
        variant: 'info-secondary',
        content: 'Suspect',
        testId: 'risk-gap-type-badge-suspect',
        className: 'bg-caution-badge text-caution-main',
      };
    }
    case 'net-new': {
      return {
        variant: 'info-secondary',
        content: 'Net-new',
        testId: 'risk-gap-type-badge-net-new',
        className: 'bg-info-badge text-info-main',
      };
    }
    default: {
      return {
        variant: 'caution-secondary',
        content: 'Unknown',
        testId: 'risk-gap-status-badge-open',
      };
    }
  }
};
